export default ({ screenSizes = {}, typography = {} }) => ({
  root: {
    '& *': {
      fontFamily: typography.fontFamilies.secondary
    },
    '& input:focus, & select:focus, & button:focus': {
      boxShadow: 'none !important'
    },
    '& input[type="color"], .colorWithGradient input[type="color"][name="color1"], .colorWithGradient input[type="color"][name="color2"]': {
      top: 35
    },
    '& .colorWithGradient input[type="color"]': {
      top: 6
    },
    '& label > p': {
      color: '#6E6E6E',
      fontSize: 12,
      fontWeight: typography.fontWeights.bold,
      textTransform: 'uppercase'
    },
    fontFamily: typography.fontFamilies.secondary
  },
  toggle: {
    '& *': {
      fontFamily: typography.fontFamilies.secondary
    },
    '& button': {
      background: 'none',
      '& > p': {
        fontWeight: typography.fontWeights.bold
      }
    },
    '& input:focus, & select:focus, & button:focus': {
      boxShadow: 'none !important'
    },
    '& p': {
      margin: 0
    },
    '&.openDrawer': {
      right: -165
    },
    position: 'fixed',
    right: 40,
    top: 155,
    zIndex: 1,
    transition: 'right .25s ease-in-out',
    [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
      display: 'none'
    }
  },
  tooltip: {
    fontFamily: typography.fontFamilies.secondary,
    maxWidth: 300
  }
});
